import { adWrap, BannerAdSizes } from "src/tags/ads/index"
import { AdTargetingData } from "src/types/ads/AdTargetingData"

// バナーのサイズ
// App: BANNER（320×50）、FULL_BANNER（468×60）、LARGE_BANNER（320×100）、MEDIUM_RECTANGLE（300×250）
// Web: number[]（[幅px、高さpx]）
const getBannerWithEndpointData = async (
  position: Position,
  size: BannerAdSizes[],
  adTargetingData: AdTargetingData,
  idNumber?: number
) => {
  if (!adTargetingData) {
    console.error("Ad targeting data is missing")
    return null
  }

  const targetingData = {
    isManager: String(adTargetingData.userAttributes?.isManager ?? false),
    gender: adTargetingData.userAttributes?.gender ?? "",
    job: adTargetingData.userAttributes?.job ?? "",
    school: adTargetingData.userAttributes?.school ?? "",
    Prefecture: adTargetingData.userAttributes?.prefecture ?? "",
    age: adTargetingData.userAttributes?.age ?? "",
    married: adTargetingData.userAttributes?.married ?? "",
    child: adTargetingData.userAttributes?.child ?? "",
    joinedFreeOrg: String(adTargetingData.userAttributes?.joinedFreeOrganization ?? false),
    orgIds: adTargetingData.userAttributes?.organizationIds ?? [],
    orgPrefectures: adTargetingData.userAttributes?.organizationPrefectures ?? [],
    orgCategories: adTargetingData.userAttributes?.organizationCategories ?? [],
    orgSubCategories: adTargetingData.userAttributes?.organizationSubCategories ?? [],
    domain: adTargetingData.userAttributes?.domain ?? "",
    accountId: adTargetingData.userAttributes?.accountId ?? "",
    platform: adTargetingData.demographic?.platform === "ios" ? "iOS" : adTargetingData.demographic?.platform ?? "",
    appVersion: adTargetingData.demographic?.appVersion ?? "",
    model: adTargetingData.demographic?.model ?? "",
  }
  adWrap.setTargeting(targetingData)
  return adWrap.BannerAd(
    {
      ios: `/13341826/a_rakuraku.ios_Plus_${position}`,
      android: `/13341826/a_rakuraku.and_Plus_${position}`,
      web: `div-gpt-ad-${webAdNo["home_top"]}-0`,
      id: `${position}_${idNumber ?? 0}`,
    },
    size,
    false
  )
}
export default getBannerWithEndpointData

export type Position =
  | "home_top"
  | "home_bottom"
  | "join_complete"
  | "group_exclusion"
  | "inbox_upper"
  | "inbox_bottom"
  | "inbox_top"
  | "outbox_upper"
  | "outbox_bottom"
  | "draft_upper"
  | "draft_bottom"
  | "template_upper"
  | "template_bottom"
  | "trash_upper"
  | "trash_bottom"
  | "mail_detail"
  | "send_complete"
  | "menu"

export const BannerAd = {
  HomeTop: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_top", ["BANNER"], adTargetingData),
  HomeBottom_1: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 1),
  HomeBottom_2: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 2),
  HomeBottom_3: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 3),
  HomeBottom_4: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 4),
  HomeBottom_5: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 5),
  HomeBottom_6: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 6),
  HomeBottom_7: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 7),
  HomeBottom_8: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 8),
  HomeBottom_9: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 9),
  HomeBottom_10: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("home_bottom", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 10),
  JoinComplete: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("join_complete", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData),
  GroupExclusion: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("group_exclusion", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData),
  InboxUpper_1: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("inbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 1),
  InboxUpper_2: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("inbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 2),
  InboxUpper_3: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("inbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 3),
  InboxUpper_4: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("inbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 4),
  InboxTop: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("inbox_top", ["BANNER"], adTargetingData),
  OutboxUpper_1: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("outbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 1),
  OutboxUpper_2: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("outbox_upper", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 2),
  MailDetail_1: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("mail_detail", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 1),
  MailDetail_2: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("mail_detail", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData, 2),
  SendComplete: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("send_complete", ["MEDIUM_RECTANGLE", "MEDIUM_RECTANGLE"], adTargetingData),
  MenuBottom: async (adTargetingData: AdTargetingData) =>
    await getBannerWithEndpointData("menu", ["ANCHORED_ADAPTIVE_BANNER"], adTargetingData),
}
const webAdNo: { [position in Position]: number } = {
  home_top: 1668161771587,
  home_bottom: 1668161837315,
  join_complete: 1668161803960,
  group_exclusion: 1668161892414,
  inbox_upper: 1668161955046,
  inbox_bottom: 1668162032262,
  inbox_top: 1668161771587,
  outbox_upper: 1668162073482,
  outbox_bottom: 1668162131372,
  draft_upper: 1668162174318,
  draft_bottom: 1668162214526,
  template_upper: 1668162254738,
  template_bottom: 1668162291439,
  trash_upper: 1668162329905,
  trash_bottom: 1668162366221,
  mail_detail: 1668162407379,
  send_complete: 1668162455577,
  menu: 1668161771587,
}
